import { Text } from "@wojo/ui";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import React, { PropsWithChildren } from "react";
import { ErrorBoundary } from "react-error-boundary";
import {
    DeparturesStepContextProvider,
    useDeparturesStepContext,
} from "../context/DeparturesStepContext";
import { DepartureFiltersContent } from "./DepartureFilters";
import { DepartureFiltersHeader } from "./DepartureFiltersHeader";
import { DepartureHeader } from "./DepartureHeader";
import { DepartureList } from "./DepartureList";
import { useTripBuilder } from "../context/TripBuilderContext";
import { useShowMarketingMessageView } from "../context/use-show-marketing-message-view";

dayjs.extend(utc);

export const TripBuilderDeparturesStep: React.FC = () => {
    const showMarketingMessageView = useShowMarketingMessageView();
    const { departure } = useTripBuilder();

    if (showMarketingMessageView || departure) {
        return null;
    }

    return (
        <ErrorBoundary
            fallback={
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "600px",
                    }}
                >
                    <Text.Body>
                        Something went wrong. Departures not loaded.
                    </Text.Body>
                </div>
            }
        >
            <DeparturesStepContextProvider>
                <TripBuilderDeparturesStepComponent />
            </DeparturesStepContextProvider>
        </ErrorBoundary>
    );
};

const TripBuilderDeparturesStepComponent: React.FC<PropsWithChildren> = () => {
    const { isFilterOpen } = useDeparturesStepContext();

    return isFilterOpen ? (
        <>
            <DepartureFiltersHeader />
            <DepartureFiltersContent />
        </>
    ) : (
        <>
            <DepartureHeader />
            <DepartureList />
        </>
    );
};
